import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import BaseOptionSetDetail from './BaseOptionSetDetail';
import BaseRequirementForm from './BaseRequirementForm';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.BASE_REQUIREMENT);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.BASE_REQUIREMENT}
      screenQueryName={EDetailsQueryNames.GetBaseRequirementDetails}
      entityId={+id}
      title={data => `Base requirement #${data?.id}`}
      cancelLink={AppRoutes.BaseRequirementList}
    >
      <BaseRequirementForm schema={schema} />
      <BaseOptionSetDetail id={+id} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
